import { produce } from 'immer';

import { UpdateInternalMarketerEditProduct } from '../../../actions/marketer/internal/updateInternalMarketerEditProduct';
import { MarketerState } from '../../../typings/marketers';

export function updateInternalMarketerEditProduct(
    state: MarketerState,
    action: UpdateInternalMarketerEditProduct
): MarketerState {
    return produce(state, draft => {
        const product = action.product;

        Object.keys(product).forEach(prop => {
            draft.editProduct[prop] = product[prop];
        });
    });
}
